import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "components/core/Link";
import { ensureAbsoluteUrl } from "utils/url";
import states from "config/states";

import "./StateLinks.scss";

const mapStateToProps = (state) => ({
	baseUrl: state.app?.baseUrl
});

function StateLinks({ baseUrl }) {
	return (
		<ul className="states-list">
			{states.map(({ abbv, url }) => (
				<li
					className="state"
					key={abbv}
				>
					<Link
						last
						weight="semiBold"
						color="lightBlue"
						className="state-link"
						href={ensureAbsoluteUrl(url, baseUrl)}
					>
						{abbv}
					</Link>
				</li>
			))}
		</ul>
	);
}

StateLinks.propTypes = {
	baseUrl: PropTypes.string
};

export { StateLinks as UnconnectedStateLinks };

export default connect(mapStateToProps)(StateLinks);
